module.exports = __webpack_public_path__ + "static/img/title.eabb514.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/feature6/title.png
// module id = 13v3
// module chunks = 7